import { Container } from "./Container";

export class FlexContainer extends Container {

    public centered() {
        this.addClass("fcenter");
    }

    public spaceAround() {
        this.addClass("fsaround");
    }

    public appendChildRight(element: any) {
        const i = element;
        i.addClass("fir");
        super.appendChild(i);
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.addClass("fc");
    }
}
